<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box"  style="width:30%">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          size="small"
          plain
          @click="addClick"
          >新增</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-top-right"
          size="small"
          plain
          @click="exportVisitorRecord()"
          :disabled="tableData.length == 0"
          >导出</el-button
        >
      </div>
      <div class="search_box" style="width:70%">
        <el-input
          class="select-input"
          v-model.trim="searchParams.visitorName"
          size="mini"
          placeholder="访客名称"
        ></el-input>
        &nbsp;
        <el-input
          class="select-input"
          v-model.trim="searchParams.intervieweeSName"
          size="mini"
          placeholder="被访人姓名"
        ></el-input>
        &nbsp;
        <el-date-picker
          class="select-input"
          :picker-options="pickerDateOptionsOne"
          v-model="searchParams.visitingTime"
          type="datetime"
          placeholder="选择来访时间"
          align="right"
          size="mini"
          value-format="timestamp"
        >
        </el-date-picker>
        &nbsp;
        <el-date-picker
          class="select-input"
          v-model="searchParams.departureTime"
          type="datetime"
          placeholder="选择离开时间"
          align="right"
          size="mini"
          value-format="timestamp"
        >
        </el-date-picker>
        &nbsp;
        <el-select
          class="select-input"
          v-model="searchParams.visitingStatus"
          size="mini"
          clearable
          placeholder="请选择来访状态"
        >
          <el-option
            v-for="item in $store.state.select.visitingStatus"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button
          size="mini"
          type="primary"
          plain
          icon="el-icon-search"
          @click="getList"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="tableData"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          v-loading="tableLoading"
        >
          <el-table-column label="序号" width="70" align="center">
            <template slot-scope="scope">
              {{
                searchParams.pageSize * (searchParams.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column prop="visitorName" label="访客名称" align="center">
          </el-table-column>

          <el-table-column prop="visitorUnit" label="访客单位" align="center">
          </el-table-column>
          <el-table-column
            prop="visitorMobileNumber"
            label="访客手机号"
            align="center"
            width="160"
          >
          </el-table-column>

          <el-table-column
            prop="intervieweeSName"
            label="被访者姓名"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="visitingTime"
            label="来访时间"
            width="160"
            align="center"
          >
            <template slot-scope="rowData">
              {{ $Common.dateFormatDateTwo(rowData.row.visitingTime) }}
            </template>
          </el-table-column>

          <el-table-column label="离开时间" width="160" align="center">
            <template slot-scope="rowData">
              {{ $Common.dateFormatDateTwo(rowData.row.departureTime) }}
            </template>
          </el-table-column>
          <el-table-column label="来访状态" width="78" align="center">
            <template slot-scope="scope"
              >{{
                $store.state.select.visitingStatus[scope.row.visitingStatus]
                  .name
              }}
            </template>
          </el-table-column>

          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="checkDetail(scope.row)"
                >详情</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-dropdown>
                <span class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="dropdown_item_box"
                    ><el-link
                      class="link_box"
                      type="primary"
                      @click="operationRow(1, scope.row.id)"
                      :disabled="scope.row.visitingStatus != 0"
                      :underline="false"
                      >同意</el-link
                    ></el-dropdown-item
                  >
                  <el-dropdown-item class="dropdown_item_box"
                    ><el-link
                      class="link_box"
                      type="primary"
                      @click="operationRow(0, scope.row.id)"
                      :disabled="scope.row.visitingStatus != 0"
                      :underline="false"
                      >拒绝</el-link
                    ></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="searchParams.pageNum"
          :page-size="searchParams.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <visitor-record-add
      :drawerShow="drawerShow"
      @handleClose="handleClose"
    ></visitor-record-add>
    <visitor-record-detail
      :checkResize="checkResize"
      :ruleForm="visitorDetail"
    ></visitor-record-detail>
  </div>
</template>

<script>
import VisitorRecordAdd from "./components/VisitorRecordAdd";
import VisitorRecordDetail from "./components/VisitorRecordDetail";
export default {
  name: "",
  components: {
    VisitorRecordAdd,
    VisitorRecordDetail
  },
  props: {},
  data() {
    return {
      pickerDateOptionsOne: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      // 请求参数
      searchParams: {
        schoolId: this.$store.state.schoolId,
        pageNum: 1,
        pageSize: 20,
        visitorName: "",
        intervieweeSName: "",
        visitingTime: "",
        departureTime: "",
        visitingStatus:''
      },
      tableData: [],
      tableLoading: false,
      total: 0,
      drawerShow: false,
      checkResize: 0,
      visitorDetail: {}
    };
  },
  watch: {},
  computed: {},
  methods: {
    async getList() {
      let req = Object.assign({}, this.searchParams);
      if (!req.visitorName) {
        delete req.visitorName;
      }
      if (!req.intervieweeSName) {
        delete req.intervieweeSName;
      }
      if (req.visitingTime) {
        req.visitingTime = parseInt(req.visitingTime) / 1000;
      } else {
        req.visitingTime = "";
      }
      if (req.departureTime) {
        req.departureTime = parseInt(req.departureTime) / 1000;
      } else {
        req.departureTime = "";
      }
      this.tableLoading = true;
      let res = await this.$Http.getVisitorRecord(req, true);
      this.tableLoading = false;
      if (res.code == 200) {
        this.tableData = res.data.list || [];
        this.total = res.data.total;
      } else if (res.code == 101) {
        this.tableData = [];
        this.total = 0;
      } else {
        this.$message({
          type: "error",
          message: res.messsage || "访客记录获取失败"
        });
      }
    },
    async exportVisitorRecord() {
      let req = {
        schoolId: this.searchParams.schoolId,
        intervieweeSName: this.searchParams.intervieweeSName,
        visitingStatus: this.searchParams.visitingStatus,
        visitorName: this.searchParams.visitorName,
        visitingTime: this.searchParams.visitingTime,
        departureTime: this.searchParams.departureTime
      };
      if (req.visitingTime) {
        req.visitingTime = parseInt(req.visitingTime) / 1000;
      } else {
        req.visitingTime = "";
      }
      if (req.departureTime) {
        req.departureTime = parseInt(req.departureTime) / 1000;
      } else {
        req.departureTime = "";
      }
      this.$Common.exportData(req, "exportVisitorRecord", "访客记录");
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchParams.pageNum = val || 1;
      this.getList();
    },
    addClick() {
      this.drawerShow = true;
    },
    checkDetail(row) {
      this.visitorDetail = row;
      this.checkResize++;
      // console.log(this.visitorDetail, this.checkResize)
    },
    handleClose(type) {
      if (type) {
        this.getList();
      }
      this.drawerShow = false;
    },
    async operationRow(val, id) {
      this.$confirm(
        val == 0
          ? "此操作将拒绝当前访客访问, 是否继续?"
          : "此操作将同意当前访客访问, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(async () => {
          let req = {
            id: id,
            mark: val
          };
          let res = await this.$Http.visitorOperation(req, true);
          if (res.code == 200) {
            this.getList();
          } else {
            this.$message({
              type: "error",
              message: res.messsage || "操作失败"
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: val == 0 ? "已取消拒绝操作" : "已取消同意操作"
          });
        });
    }
  },
  created() {},
  mounted() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.select-input {
  width: 174px;
}
</style>
